import { useEffect, useState } from "react"
import { X } from "react-feather"

const fallbackImage = "/Static/Assets/Img/sidePicView.png"

export const ImageViewPopup = ({ imageUrl, alt = "Preview", onClose }) => {
    const [imageSource, setImageSource] = useState(imageUrl)
    const [isLoading, setIsLoading] = useState(Boolean(imageUrl))

    useEffect(() => {
        setImageSource(imageUrl)
        setIsLoading(Boolean(imageUrl))
    }, [imageUrl])

    if (!imageUrl) return null

    return (
        <div className="seminar-backdrop custom">
            <div className="modal-dialog modal-dialog-centered seminar-dialog image-view-dialog">
                <div className="modal-content seminar-content" role="dialog" aria-modal="true" aria-label={alt}>
                    <div className="d-flex align-items-center justify-content-between seminar-header">
                        <h6 className="m-0 fw-bold">Image Preview</h6>
                        <button type="button" className="btn-close btn-close-white seminar-close" onClick={onClose} aria-label="Close" />
                    </div>

                    <div className="seminar-body image-view-content" aria-busy={isLoading}>
                        {isLoading && <div className="image-view-loader" role="status" aria-label="Loading image" />}
                        <img
                            src={imageSource}
                            alt={alt}
                            loading="lazy"
                            decoding="async"
                            className={`image-view-image ${isLoading ? "image-view-loading" : ""} ${imageSource === fallbackImage ? "image-view-fallback" : ""}`}
                            onLoad={() => setIsLoading(false)}
                            onError={() => {
                                if (imageSource === fallbackImage) {
                                    setIsLoading(false)
                                } else {
                                    setImageSource(fallbackImage)
                                    setIsLoading(true)
                                }
                            }}
                        />
                    </div>

                    <div className="d-flex justify-content-end seminar-footer">
                        <button type="button" className="btn btn-danger seminar-btn-cancel" onClick={onClose}>
                            <X size={15} className="me-1" />
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
